import { useSysconfig } from '~/components/SystemConfiguration/SystemConfigurationScreen';
import useDataFetcher from '~/components/useDataFetcher';
import type { SnapshotDatesResponse } from '~/server_shared/openapi/data-contracts';

export const useSnapshotDates = () => {
  // @ts-expect-error TODO: useSysconfig hook needs TypeScript definition
  const { organization } = useSysconfig();

  const url = `/sysconfig/api/v1/organizations/${organization.id}/reports/generated/snapshot-dates`;

  const { isLoading, data } = useDataFetcher<SnapshotDatesResponse>(url);

  return {
    dates: data?.dates || [],
    isLoading,
  };
};
